import React, { createContext, useContext, useRef, useCallback } from 'react';

const MapSyncContext = createContext(null);

export function MapSyncProvider({ children }) {
    // Use ref to avoid re-renders when view changes
    const sharedViewRef = useRef({ zoom: null, center: null });

    const setSharedView = useCallback((zoom, center) => {
        sharedViewRef.current = { zoom, center };
    }, []);

    const getSharedView = useCallback(() => {
        return sharedViewRef.current;
    }, []);

    const value = {
        setSharedView,
        getSharedView
    };

    return (
        <MapSyncContext.Provider value={value}>
            {children}
        </MapSyncContext.Provider>
    );
}

export function useMapSync() {
    const context = useContext(MapSyncContext);
    if (!context) {
        throw new Error('useMapSync must be used within a MapSyncProvider');
    }
    return context;
}
